module.exports = __webpack_public_path__ + "static/img/2_2_1.9f2c8b10.jpg";